import { useState, useEffect } from "react";
import { useErs } from "src/context/ers/ers.provider";
import { useEntertainmentHub } from "src/hooks/useEntertainmentHub";
import { isPayloadEntertainmentSource } from "src/utils/entertainmentSource";

/**
 * Unified entertainment hub loader — ERS or Payload based on REACT_APP_ENTERTAINMENT_SOURCE.
 *
 * @param {string} locale - `en` | `fr`
 * @returns {{
 *   events: import('src/utils/mapEntertainment').EntertainmentCard[] | undefined,
 *   loading: boolean,
 *   error: string | null,
 * }}
 */
export function useEntertainmentHubData(locale) {
  const usePayload = isPayloadEntertainmentSource();
  const { data: ersData, fetchData, error: ersError } = useErs();
  const payload = useEntertainmentHub(locale);

  const [ersLoading, setErsLoading] = useState(!usePayload);

  useEffect(() => {
    if (usePayload) return;

    setErsLoading(true);

    fetchData(`entertainment-${locale}`)
      .catch((err) => {
        console.error("Error fetching entertainment from ERS:", err);
      })
      .finally(() => {
        setErsLoading(false);
      });
  }, [usePayload, fetchData, locale]);

  if (usePayload) {
    return {
      events: payload.data,
      loading: payload.loading,
      error: payload.error,
    };
  }

  return {
    events: ersData[`entertainment-${locale}`],
    loading: ersLoading,
    error: ersError,
  };
}
